import React, { useRef, useState } from "react";
import styles from "./MailMergeStatusRenderer.module.css";
import { Button, Overlay, Tooltip } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";

/**
 * MailMergeStatusRenderer Component
 */
const MailMergeStatusRenderer: React.FC = (mailmerge_status_props: any) => {
  const { Status, MailMergeMessage } = mailmerge_status_props.data;
  const [showTooltip, setShowTooltip] = useState(false);
  const target = useRef(null);

  const formatMessage = (message: any) =>
    message.split("\n").map((line: any, index: any) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));

  const handleClick = () => setShowTooltip((prev) => !prev);

  return Status !== "" ? (
    <div className={styles.approvalStatusWrapper}>
      <span style={{ flexGrow: 1, textAlign: "left" }}>
        {Status}
      </span>
      {String(Status).trim().toLowerCase().includes("incomplete") && <>
        <Button
          className={styles.patchQuestionIcon}
          ref={target}
          onClick={handleClick}
        >
          <Icon.PatchQuestion />
        </Button>

        <Overlay
          target={target.current}
          show={showTooltip}
          placement="left"
          rootClose
          onHide={() => setShowTooltip(false)}
        >
          {(props: any) => (
            <Tooltip {...props} id="button-tooltip">
              {MailMergeMessage ? formatMessage(MailMergeMessage) : Status}
            </Tooltip>
          )}
        </Overlay>
      </>}
    </div>
  ) : null;
};

export default MailMergeStatusRenderer;
